/* eslint-disable no-underscore-dangle */
import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import mobile from 'is-mobile';
import { DashboardCard } from 'module-tsl-resource-components';
import { deleteSaved, addToSelection, removeFromSelection } from '../../modules/SavedModule';
import { addUndoableAction } from '../../modules/ProfileModule';
import { emitClick } from '../../modules/Mz';

const readCookie = (k) => (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2];

export function getFormatedPrice(resource) {
  if (resource.priceObjV4) {
    const priceObject = resource.priceObjV4.forexPrices.find(po => po.country === readCookie('siteCountry'));
    return priceObject.price;
  }
  return 'Free';
}

@connect(
  (state) => ({ selection: state.savedModule.selection }),
  { deleteSaved, addToSelection, removeFromSelection, addUndoableAction, emitClick },
)
export default class SavedRow extends Component {
  handleAddToBasketCheckboxChange = (e) => {
    if (e.target.checked) this.props.emitClick('add-resource-to-basket', this.props.item.resource._id);
    if (!e.target.checked) this.props.emitClick('remove-resource-from-basket', this.props.item.resource._id);
    const resourceId = this.props.item.resource._id;
    if (e.target.checked) return this.props.addToSelection(resourceId);
    this.props.removeFromSelection(resourceId);
  };

  render() {
    const { item: { resource } } = this.props;

    return (
      <DashboardCard
        cardType="resource"
        resourceUrl={resource.url}
        resourceId={resource._id}
        authorUsername={resource.authorUsername}
        date={moment(resource.savedDate).format('DD MMM YYYY')}
        formattedPrice={getFormatedPrice(resource)}
        licenceCode={resource.licence}
        licenceTooltip={resource.licenceDescription}
        owns={(!resource.price || resource.owned) && !mobile()}
        title={resource.title}
        noRatingButtons
        noDeleteButton={mobile()}
        noBuyButton={!resource.price || resource.owned}
        onDeleteButtonClick={() => this.props.addUndoableAction({
          action: () => this.props.deleteSaved(resource._id),
          message: 'Resource removed from saved list. ',
        })}
        downloadButtonHref={resource.downloadUrl}
        onDownloadButtonClick={() => {
          this.props.emitClick('download-resource', resource._id);
        }}
        onBasketCheckboxChange={this.handleAddToBasketCheckboxChange}
        basketCheckboxChecked={!!this.props.selection[resource._id]}
        noAddToBasketCheckbox={true}
        buyButtonHref={`/teaching-resource/resource-${resource._id}`}
      />
    );
  }
}

SavedRow.propTypes = {
  emitClick: PropTypes.func,
  item: PropTypes.object,
  addToSelection: PropTypes.func,
  removeFromSelection: PropTypes.func,
  addUndoableAction: PropTypes.func,
  deleteSaved: PropTypes.func,
  selection: PropTypes.object,
};
